<template>
  <div class="relative bg-black text-gray-100 overflow-hidden pt-20 pb-40">
    <video autoplay loop muted class="hidden 3xl:block absolute top-0 left-0 w-full max-w-[945px] max-h-[805px]">
      <source src="@/assets/images/moving-arc.webm" type="video/webm" />
    </video>

    <ContentContainer>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-y-40">
        <div>
          <div class="text-heading-h2 md:text-heading-h1 font-heading font-semibold"
               v-html="$t('benefits.title')"
          ></div>
        </div>

        <div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-22 gap-y-28">
            <div v-for="item in items" :key="item.key"
            >
              <div class="mx-auto md:mx-0 flex flex-col items-center md:items-start max-w-[280px]">
                <div>
                  <img :src="require(`@/assets/images/benefits/${item.key}.svg`)"
                       class="h-20 max-w-[90vw]"
                  />
                </div>

                <div class="mt-10 text-center md:text-left font-heading font-semibold text-heading-h3">
                  {{ item.name }}
                </div>

                <div class="mt-8 text-center md:text-left text-body-m font-body">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentContainer>
  </div>
</template>
<script>
import ContentContainer from "@/components/ui/ContentContainer.vue";

export default {
  components: {
    ContentContainer,
  },

  data() {
    return {
      items: [
        {
          key: 'energy',
          name: this.$t('benefits.items.energy.name'),
          description: this.$t('benefits.items.energy.description'),
        },
        {
          key: 'lifespan',
          name: this.$t('benefits.items.lifespan.name'),
          description: this.$t('benefits.items.lifespan.description'),
        },
        {
          key: 'efficiency',
          name: this.$t('benefits.items.efficiency.name'),
          description: this.$t('benefits.items.efficiency.description'),
        },
        {
          key: 'emissions',
          name: this.$t('benefits.items.emissions.name'),
          description: this.$t('benefits.items.emissions.description'),
        },
      ],
    }
  },
}
</script>
